function Mapper () {
  function cartProduct (product) {
    return {
      cartId: product.id_token,
      productId: product.product_id_token,
      slug: product.slug,
      images: product.product_images.map(img => img.url),
      inco_terms: product.inco_terms,
      availableincoTerms: product.available_inco_terms,
      name: product.product_name,
      quantity: parseInt(product.quantity),
      displayMoq: product.display_moq,
      highestExwPrice: product.highest_exw_price,
      highestFobPrice: product.highest_fob_price,
      lowestExwPrice: product.lowest_exw_price,
      lowestFobPrice: product.lowest_fob_price,
      minimumOrderQuantity: parseInt(product.minimum_order_quantity),
      price: product.price,
      quantityIncrement: parseInt(product.quantity_increment),
      unit: product.unit,
      supplier: {
        id: product.supplier.supplier_id_token,
        name: product.supplier.company_name
      },
      pricing: product.pricing.map(price => {
        return {
          displayExwPrice: price.display_exw_price,
          displayFobPrice: price.display_fob_price,
          exwPrice: price.exw_price,
          fobPrice: price.fob_price,
          maxQuantity: price.quantity_max
        }
      }),
      brand: product.brand,
      sku: product.sku,
      categoryName: product.category_name
    }
  }

  return {
    cartProduct
  }
}

export default Mapper()
